<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="DOWNLOAD REPORT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(downloadReportDocument)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Select month and year</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="flatPkrConfig"
                            v-model="date"
                            placeholder=""
                />
                <flat-pickr
                  class="w-full"
                  :config="flatPkrConfig"
                  v-model="date"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="industry_sector" name="industry_sectors" rules="" v-slot="{ errors }">
                <small class="label">Industry Section</small>
              <v-select :clearable="true" placeholder="industry Sector" v-model="selectedIndustrySector"
                        multiple
                        :options="industrySectors"
                        label="name"
                        :reduce="option => option.value"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="currencies" name="currencies" rules="" v-slot="{ errors }">
                <small class="label">Account Currency</small>
              <v-select :clearable="true" placeholder="Currency" v-model="selectedCurrency"
                        :options="currencies"
                        multiple
                        label="name"
                        :reduce="option => option.value"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get('reporting')
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import Utils from "@/mixins/Utils";
import vSelect from 'vue-select'

export default {
  name: "DownloadReportPopUp",
  data () {
    return {
      open: false,
      endPoint: '',
      date:'',
      industrySectors:[],
      currencies:[],
      selectedIndustrySector:null,
      selectedCurrency:null
    }
  },
  mixins:[Utils],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  methods:{
    openPopup(end_point, filters) {
      this.open = true
      this.endPoint = end_point
      this.selectedCurrency = filters.account_currency ? filters.account_currency: []
      this.selectedIndustrySector = filters.industry_sector? filters.industry_sector: []
      this.industrySectors = this.getDropdownData('industry_sector')
      this.currencies = this.getDropdownData('account_currency')
    },
    async downloadReportDocument(){
      this.$vs.loading()
      try {
        const response = await ReportingRepository.downloadReportDocument(this.endPoint, `month_year=${this.date}&filter[industry_sector]=${this.selectedIndustrySector}&filter[account_currency]=${this.selectedCurrency}`)
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `Sales Revenue Report (${this.date}).xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.open = false
      } catch (e) {

      }
      this.$vs.loading.close()
    }
  },
  computed: {
    flatPkrConfig: function () {
      return {
        dateFormat: 'm/Y',
        plugins: [
          new MonthSelectPlugin({
            shorthand: true,
            dateFormat: "m/Y",
          })
        ],
      }
    }
  }
}
</script>

<style scoped>

</style>
